<template>
  <div class="row vh-100 d-flex justify-content-center">
    <div class="col-12 align-self-center">
      <div class="row">
        <div class="col-lg-5 mx-auto">
          <div class="card">
            <div class="card-body">
              <div class="ex-page-content text-center">
                <h1 class="mt-5 mb-4">403!</h1>
                <h5 class="font-16 text-muted mb-5">شما به این بخش دسترسی ندارید</h5>
              </div>
              <router-link class="btn btn-primary btn-block waves-effect waves-light" to="/">بازگشت به داشبورد <i class="fas fa-redo ml-1"></i></router-link>
            </div>
          </div><!--end card-->
        </div><!--end col-->
      </div><!--end row-->
    </div><!--end col-->
  </div><!--end row-->
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "403",
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('404');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  },
}
</script>

<style scoped>

</style>